var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    view26Wrapper: true,
    cardWidth: true,
  
  }},[_c('div',{staticClass:"v26Content"},[_c('PoetryContent',{attrs:{"data":_vm.list[0]}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }